// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"4baba08f","70":"8fdb0f72","71":"d91a6763","195":"7d12e84b","293":"68d5f295","349":"073cf978","360":"12a5e1e9","401":"22a4839e","419":"36b2af41","606":"fe3244d4","621":"4b585715","635":"8ad59462","832":"4c9defa4","870":"4df1861b"}[chunkId] + ".chunk.js";
};